/* ============================================================
   Collection infinite scroll (Dawn) — v3
   - Scroll-position trigger (no IntersectionObserver) for reliability.
   - Derives next page from the current URL (keeps filters/sort).
   - Chain-loads to fill the viewport, then loads as you scroll.
   - Re-initialises when Dawn's facet filters replace the grid.
   - Logs with the [infinite-scroll] prefix.
   ============================================================ */
(function () {
  'use strict';

  var LOG = '[infinite-scroll]';
  var CONTAINER_ID = 'ProductGridContainer';
  var TRIGGER_PX = 1000; // start loading when within this many px of the grid end

  if (!document.getElementById('infinite-scroll-styles')) {
    var st = document.createElement('style');
    st.id = 'infinite-scroll-styles';
    st.textContent =
      '.infinite-scroll__status{display:none;justify-content:center;align-items:center;' +
      'padding:2.4rem 0;min-height:4rem;}' +
      '.infinite-scroll__status.is-loading{display:flex;}' +
      '.infinite-scroll__spinner{width:2.4rem;height:2.4rem;border-radius:50%;' +
      'border:0.3rem solid rgba(var(--color-foreground),0.2);' +
      'border-top-color:rgb(var(--color-foreground));' +
      'animation:infinite-scroll-spin 0.7s linear infinite;}' +
      '@keyframes infinite-scroll-spin{to{transform:rotate(360deg);}}' +
      '.infinite-scroll__sentinel{width:100%;height:1px;}';
    document.head.appendChild(st);
  }

  function findGridList(scope) {
    var pg = scope.querySelector('#product-grid');
    if (!pg) return null;
    return pg.tagName === 'UL' ? pg : pg.querySelector('ul');
  }

  function InfiniteScroll(container) {
    this.container = container;
    this.grid = findGridList(container);
    if (!this.grid) { console.log(LOG, 'no product grid found — aborting'); return; }

    var params = new URLSearchParams(window.location.search);
    this.page = parseInt(params.get('page') || '1', 10) || 1;
    this.perPage = this.grid.querySelectorAll(':scope > li').length || 0;
    this.loading = false;
    this._ticking = false;

    this.paginationNav = this.findPaginationNav();
    this.hasNext = this.detectNext();

    console.log(LOG, 'init', { page: this.page, perPage: this.perPage, hasNext: this.hasNext });
    if (!this.hasNext) return;

    this.hidePagination();
    this.buildUI();
    this.bind();
    this.maybeLoad();
  }

  InfiniteScroll.prototype.findPaginationNav = function () {
    var list = this.container.querySelector('.pagination__list');
    return list ? list.closest('nav') : this.container.querySelector('nav.pagination');
  };

  InfiniteScroll.prototype.detectNext = function () {
    var marker = this.container.querySelector('.infinite-scroll-marker[data-next-url]');
    if (marker && marker.getAttribute('data-next-url')) return true;
    if (this.paginationNav) {
      var links = this.paginationNav.querySelectorAll('a[href]');
      for (var i = 0; i < links.length; i++) {
        var p = new URLSearchParams(links[i].search).get('page');
        if (p && parseInt(p, 10) > this.page) return true;
      }
    }
    return false;
  };

  InfiniteScroll.prototype.hidePagination = function () {
    if (this.paginationNav) this.paginationNav.setAttribute('hidden', '');
  };
  InfiniteScroll.prototype.showPagination = function () {
    if (this.paginationNav) this.paginationNav.removeAttribute('hidden');
  };

  InfiniteScroll.prototype.buildUI = function () {
    var anchor = this.grid.parentNode;
    this.status = document.createElement('div');
    this.status.className = 'infinite-scroll__status';
    this.status.setAttribute('role', 'status');
    this.status.innerHTML = '<span class="infinite-scroll__spinner" aria-hidden="true"></span>';
    anchor.appendChild(this.status);

    this.sentinel = document.createElement('div');
    this.sentinel.className = 'infinite-scroll__sentinel';
    this.sentinel.setAttribute('aria-hidden', 'true');
    anchor.appendChild(this.sentinel);
  };

  InfiniteScroll.prototype.bind = function () {
    var self = this;
    this._onScroll = function () {
      if (self._ticking) return;
      self._ticking = true;
      requestAnimationFrame(function () { self._ticking = false; self.maybeLoad(); });
    };
    window.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onScroll, { passive: true });
  };
  InfiniteScroll.prototype.unbind = function () {
    if (this._onScroll) {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
    }
  };

  InfiniteScroll.prototype.maybeLoad = function () {
    if (this.loading || !this.hasNext || !this.sentinel) return;
    var top = this.sentinel.getBoundingClientRect().top;
    if (top - window.innerHeight < TRIGGER_PX) this.loadMore();
  };

  InfiniteScroll.prototype.buildNextUrl = function () {
    var params = new URLSearchParams(window.location.search);
    params.set('page', String(this.page + 1));
    return window.location.pathname + '?' + params.toString();
  };

  InfiniteScroll.prototype.loadMore = function () {
    if (this.loading || !this.hasNext) return;
    this.loading = true;
    if (this.status) this.status.classList.add('is-loading');

    var self = this;
    var url = this.buildNextUrl();
    console.log(LOG, 'fetching', url);

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var newGrid = findGridList(doc);
        var items = newGrid ? newGrid.querySelectorAll(':scope > li') : [];
        console.log(LOG, 'received', items.length, 'items');

        if (!items.length) { self.finish(); self.loading = false; if (self.status) self.status.classList.remove('is-loading'); return; }

        var frag = document.createDocumentFragment();
        Array.prototype.forEach.call(items, function (li) { frag.appendChild(li); });
        self.grid.appendChild(frag);
        self.page += 1;

        if (typeof window.initializeScrollAnimationTrigger === 'function') {
          window.initializeScrollAnimationTrigger(self.grid);
        } else {
          self.grid.querySelectorAll('.scroll-trigger').forEach(function (el) {
            el.classList.remove('scroll-trigger', 'animate--slide-in');
          });
        }

        if (self.perPage && items.length < self.perPage) {
          self.finish();
        } else {
          self.hasNext = self.fetchedHasNext(doc);
          if (!self.hasNext) self.finish();
        }

        self.loading = false;
        if (self.status) self.status.classList.remove('is-loading');
        // keep filling if still near the bottom
        self.maybeLoad();
      })
      .catch(function (err) {
        console.log(LOG, 'error', err.message, '— restoring pagination');
        self.loading = false;
        if (self.status) self.status.classList.remove('is-loading');
        self.finish();
        self.showPagination();
      });
  };

  InfiniteScroll.prototype.fetchedHasNext = function (doc) {
    var marker = doc.querySelector('.infinite-scroll-marker[data-next-url]');
    if (marker && marker.getAttribute('data-next-url')) return true;
    var nav = doc.querySelector('nav.pagination, .pagination');
    if (nav) {
      var links = nav.querySelectorAll('a[href]');
      for (var i = 0; i < links.length; i++) {
        var p = new URLSearchParams(links[i].search).get('page');
        if (p && parseInt(p, 10) > this.page) return true;
      }
    }
    return false;
  };

  InfiniteScroll.prototype.finish = function () {
    console.log(LOG, 'no more pages — done');
    this.hasNext = false;
    this.unbind();
    if (this.sentinel) this.sentinel.remove();
    if (this.status) this.status.remove();
  };

  InfiniteScroll.prototype.destroy = function () {
    this.unbind();
  };

  var instance = null;
  function init() {
    var container = document.getElementById(CONTAINER_ID);
    if (!container) { console.log(LOG, 'no #' + CONTAINER_ID + ' on page'); return; }
    if (instance) instance.destroy();
    instance = new InfiniteScroll(container);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    init();
    var container = document.getElementById(CONTAINER_ID);
    if (!container || !('MutationObserver' in window)) return;
    var mo = new MutationObserver(function () { init(); });
    mo.observe(container, { childList: true });
  });
})();
